import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { ResponsiveBar } from '@nivo/bar'
import Box from '@material-ui/core/Box'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
}))

export default function ClassifyPlants({
    plotData,
    units,
    statisticUnit,
    setStatisticUnit,
    statisticGroups,
    setStatisticGroups
}) {
    const classes = useStyles()
    const { t } = useTranslation()

    const handleChangeStatisticUnit = (e) => {
        setStatisticUnit(e.target.value)
    }

    const handleChangeStatisticGroups = (e) => {
        setStatisticGroups(e.target.value)
    }

    return (
        <div className={classes.root}>
            <Box display="flex" alignItems="flex-start">
                <Box p={1}>
                    <Typography variant="body1">{t('Classify by')}</Typography>
                </Box>
                <Box style={{ marginTop: 4 }}>
                    <FormControl className={classes.formControl}>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={statisticUnit}
                            onChange={handleChangeStatisticUnit}
                        >
                            {units.map((unit) => (
                                <MenuItem key={unit} value={unit}>{t(unit)}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>

                <Box p={1}>
                    <Typography variant="body1">{t('in')}</Typography>
                </Box>

                <Box style={{ marginTop: 4 }}>
                    <FormControl className={classes.formControl}>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={statisticGroups}
                            onChange={handleChangeStatisticGroups}
                        >
                            {[3,4,5,6,7,8,9,10].map((unit) => (
                                <MenuItem key={unit} value={unit}>{unit}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>

                <Box p={1}>
                    <Typography variant="body1">{t('groups')}.</Typography>
                </Box>
            </Box>

            <div style={{ height: 240, width: '100%' }}>
                {plotData && (
                    <ResponsiveBar
                        data={plotData}
                        keys={['count']}
                        indexBy="index"
                        colors={(d) => d.data.indexColor}
                        margin={{
                            top: 20,
                            bottom: 30,
                            left: 30,
                        }}
                        borderColor={{
                            from: 'color',
                            modifiers: [['darker', 1.6]],
                        }}
                        padding={0.4}
                        valueScale={{ type: 'linear' }}
                        indexScale={{ type: 'band', round: true }}
                        //colors={{ scheme: 'nivo' }}
                        animate={true}
                        enableLabel={false}
                        axisTop={null}
                        axisRight={null}
                        axisLeft={{
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0,
                            legend: 'index',
                            legendPosition: 'middle',
                            legendOffset: -40,
                        }}
                        labelTextColor={{
                            from: 'color',
                            modifiers: [['darker', 1.6]],
                        }}
                    />
                )}
            </div>
        </div>
    )
}
